/*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ErrorInfo from '../../Messages';
import { useTranslation } from 'react-i18next';
import { convertToLocale } from 'scripts/components/Utils/market';

const SelectedNews = ({ market }) => {
    const [news, setNews] = useState([]);
    const { t } = useTranslation();
    const [error, setError] = useState(false)

    useEffect(() => {
        axios({
            method: 'get',
            baseURL: process.env.REACT_APP_CONTURA_HEADLESS_BASE_URL,
            url: '/rest-api/mediaApi/articles',
            params: {
                market: convertToLocale(market),
                sort: true,
                limit: 3,
            },
        }).then((res) => {
            setNews(res.data);
        }).catch((error) => {
            setError(true)
            console.error(error); // eslint-disable-line
        });
    }, [market]);

    return (
        <>
            {news.length > 0 &&
                <div className="selected-news">
                    {
                        news.map((post) => {
                            return (
                                <Link
                                    key={post.id}
                                    className="news-card"
                                    to={`/news/${post.id}`}
                                >
                                    <img
                                        className="card-img"
                                        src={post.image}
                                        alt="Contura news"
                                    />
                                    <div className="card-text">
                                        <h3 className="card-title">{post.title}</h3>
                                    </div>
                                </Link>
                            );
                        })
                    }

                </div>
            }
            {error &&
                <ErrorInfo text={t('error.title.news')} />
            }
        </>

    );
}

export default SelectedNews;